import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
  userDocumentTypes: [],
  customerDataSetup: {},
  principalSetup: {},
  transferReport: []
}

const getters = {
  getUserDocumentTypes: (state) => state.userDocumentTypes,
  getCustomerDataSetup: (state) => state.customerDataSetup,
  getPrincipalSetup: (state) => state.principalSetup,
  getTransferReport: (state) => state.transferReport
};

const actions = {
    async getPrincipalSetup(context) {
        await axios.get(`${backendUrl()}/getPrincipalSetup`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setPrincipalSetup', response.data)
        })
    },
    async getCustomerDataSetup(context) {
        await axios.get(`${backendUrl()}/getCustomerDataSetup`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setCustomerDataSetup', response.data)
        })
    },
    async getUserDocumentTypes(context) {
        await axios.get(`${backendUrl()}/getUserDocumentTypes`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setUserDocumentTypes', response.data)
        })
    },
    async addOrUpdateCustomers(context, data) {
        await axios.post(`${backendUrl()}/addOrUpdateCustomers`, data,
        {
          headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async addCustomer(context, data) {
        await axios.post(`${backendUrl()}/addCustomer`, data,
        {
          headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async transferCustomer(context, data) {
        await axios.post(`${backendUrl()}/transferCustomer`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setTransferReport', response.data.responseData)
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async updateSendOptionsByCsv(context, data) {
        await axios.post(`${backendUrl()}/updateSendOptionsByCsv`, data,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': "bearer " +  vuecookie.get('token')
            }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    }
    /*
    async downloadCustomerTransferSuccessCSV(context, data) {
        await axios.post(`${backendUrl()}/downloadCustomerTransferSuccessCSV`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    }*/
    /*
    async downloadCustomerTransferSuccessCSV(context, data) {
        await axios.get(`${backendUrl()}/downloadCustomerTransferSuccessCSV/` + data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    }*/
};

const mutations = {
  setUserDocumentTypes:(state, userDocumentTypes) => (state.userDocumentTypes = userDocumentTypes),
  setCustomerDataSetup:(state, customerDataSetup) => (state.customerDataSetup = customerDataSetup),
  setPrincipalSetup:(state, principalSetup) => (state.principalSetup = principalSetup),
  setTransferReport: (state, transferReport) => (state.transferReport = transferReport)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
